// ══════════════════════════════════════════════════════════
// DEFINICIÓN DE LOS 8 ESPECIALES PASIVOS
// ══════════════════════════════════════════════════════════

export interface SpecialDefinition {
  id: string;
  name: string;
  description: string;
  icon: string; // emoji o clave de icono
}

export const SPECIALS: SpecialDefinition[] = [
  {
    id: 'escudo_inicial',
    name: '🛡️ Escudo Inicial',
    description: 'Bloquea el primer golpe recibido (daño y knockback = 0). Escudo visual brillante.',
    icon: '🛡️',
  },
  {
    id: 'regeneracion',
    name: '💚 Regeneración',
    description: 'Recupera 5 HP cada 3s si el HP es menor al 100%.',
    icon: '💚',
  },
  {
    id: 'campo_repulsivo',
    name: '🌀 Campo Repulsivo',
    description: 'Empuja suavemente peonzas en radio 80px (fuerza radial saliente).',
    icon: '🌀',
  },
  {
    id: 'rastro_fuego',
    name: '🔥 Rastro de Fuego',
    description: 'Deja partículas de fuego. Peonzas en el rastro reciben 1 HP/s.',
    icon: '🔥',
  },
  {
    id: 'giro_explosivo',
    name: '💥 Giro Explosivo',
    description: 'Al recibir golpe, libera onda expansiva (daño 8, knockback medio). Cooldown 5s.',
    icon: '💥',
  },
  {
    id: 'mas_grande',
    name: '📏 Más Grande',
    description: 'Escala 1.3x, masa 1.5x. Más fácil de golpear y empujar.',
    icon: '📏',
  },
  {
    id: 'garra_magnetica',
    name: '🧲 Garra Magnética',
    description: 'Al estar a <40px del borde, aplica fuerza hacia el centro. Difícil de sacar.',
    icon: '🧲',
  },
  {
    id: 'berserker',
    name: '⚔️ Berserker',
    description: 'Cada golpe recibido: +5% daño de ataque (acumulable, max 50%). Toda la partida.',
    icon: '⚔️',
  },
];
